// Header the proxy sets from the request host so server components can resolve the
// tenant company (white-label subdomain) without querying the DB on the Edge.
export const COMPANY_HEADER_SLUG = "x-company-slug";

// Header the proxy sets with the resolved (locale-prefixed) pathname, so the root layout
// can gate a subdomain's tool pages behind auth without every page repeating the check.
export const COMPANY_HEADER_PATHNAME = "x-pathname";

// Hosts under which the first label is treated as a company slug (subdomain).
export const COMPANY_BASE_DOMAINS = [".meidly.com", ".localhost"];

// First labels that are never a company (apex helpers / infra).
export const COMPANY_RESERVED_SUBDOMAINS = ["www", "app", "api", "admin", "mail"];

// Apex domain the white-label subdomains live under (<slug>.meidly.com).
export const TENANT_APEX_DOMAIN = COMPANY_BASE_DOMAINS[0].slice(1);
